import { InsightsDashboardSetupRequest } from "src/app/components/InsightsDashboard/utils";
import { InsightsDashboardFilters } from "./types";

export const initialFilters: InsightsDashboardFilters = {
  countries: [],
  platforms: [],
  hashtags: [],
  mentions: [],
};

export interface SocialInsightsDashboardListElement {
  name: string;
  uuid: string;
  ownerWsMemberUuid?: string | null;
  ownerName?: string | null;
  ownerAvatarUrl?: string | null;
  createdAt?: string | null;
  isSystem?: boolean;
  filters: InsightsDashboardSetupRequest & {
    // Local-only UI preference, no longer sent to or required from the backend.
    showTrends?: boolean;
    dateFrom: string | null;
    dateTo: string | null;
    dateRange: string | null;
  };
}
